module.exports = __webpack_public_path__ + "img/upper-egypt-md.94a229d9.jpeg";